/* @flow */
import { List, Map, Record, fromJS } from 'immutable';
import * as Types from './types';
import moment from 'moment-timezone';
import jstz from 'jstz';
import {LOGICAL_TYPE, NON_LOGICAL_TYPE} from 'modules/summaries/constants';

export const currentTimeZone = jstz.determine().name();
export const resolveSummaryEndpoint = (reportGuid: string) => `/services/entity-reports/${reportGuid}/summary`;

/* Normalizes summaries */
export const normalizeSummary = (rawSummary: Object): Map<string, any> => {
  return Types.Summary(rawSummary)
    .update('attributes', fromJS)
    .update('source', fromJS)
    .update('score', fromJS)
};



/**
 * Format the display of different summary variables
 * @param value
 * @param logicalType:
 * @param timezone
 * @returns {string}
 */
export const formatLogicalTypeValue = (value: any = '-', logicalType: string, timezone: any) => {
  let formattedValue = value.toString();

  try {
    switch (logicalType) {
      case LOGICAL_TYPE.EPOCH:
        const timestampDate = moment(value);
        const localizedTimestampDate = timestampDate.tz(timezone).format('YYYY-MM-DD HH:mm:ss z');
        formattedValue = `${localizedTimestampDate}`;
        break;
      default:
        break;
    }
  } catch (_) {
    formattedValue = '-';
  }

  return formattedValue;
};


/**
 * Relying on Record.isEmpty to determine undefined summary no longer applies since upgrading to immutable.js v4
 * A summary without an associated report or enclave id can be assumed to be empty
 * @param summary
 * @returns {boolean}
 */
export const isSummaryEmpty = (summary: any) => {
  return summary.get ? !summary.get('reportId') && !summary.get('enclaveId') : true;
};



// WEBPACK FOOTER //
// ./src/app/modules/summaries/utils.js